export default __webpack_public_path__ + "static/media/promo-sport.9eb9143e.png";